@if(loader){
<app-loader></app-loader>
}

<p-card [header]="isEditMode ? 'Update Manufacturing Job' : 'Create Manufacturing Job'">
  <form [formGroup]="manufacturingOrdersForm">
    <div>
      <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex">
          <div>
            @if(isEditMode){
            @if(status !== 'Batch Finished'){
            <p-button label="Update" severity="info" (click)="update(manufacturingOrdersForm.getRawValue())"
              icon="pi pi-arrow-circle-up" size="small"></p-button>
            <p-button label="Finish Job" class="p-button-outlined ml-2" icon="pi pi-check" severity="success"
              size="small" (click)="finish(manufacturingOrdersForm.getRawValue())"></p-button>
            <p-button label="Delivery Challan" class="p-button-outlined ml-2" icon="pi pi-plus-circle" size="small"
              (click)="navigateToCreateChallan()"></p-button>
            @if(hasPendingPO){
            <p-button label="Auto PO" class="p-button-outlined ml-2" icon="pi pi-shopping-cart" severity="info"
              size="small" (click)="autoPO()"></p-button>
            }
            }
            }@else {
            <p-button label="Create Job" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
              (click)="saveMO(manufacturingOrdersForm.value,isEditMode)"></p-button>
            }
          </div>
          <div>
            <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
              (click)="cancel()"></p-button>
          </div>
        </div>
        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
      </div>


      <div class="grid mt-4">
        <div class="col">
          <div class="flex gap-3">

            <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
              <div class="field text-left">
                <label for="website" class="label-required display">Job Number</label>
                <div class="flex align-items-center">
                  <input pInputText placeholder="e.g P307" type="text" (blur)="checkMONumber()"
                    [readonly]="isEditMode || !formControls.manualEntry.value"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.batchNumber.errors }"
                    class="w-full p-inputtext-sm" formControlName="batchNumber" />
                  <div *ngIf="!isBatchNumberReadOnly && !isEditMode" class="ml-2">
                    <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                      label="Manual Entry" value="true"></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="flex gap-3 items-center mt-2">
                <div class="field text-left" style="display: flex; flex-direction: column; flex: 1;">
                  <label class="label-required display">Bill Of Materials</label>
                  <div style="display: flex; align-items: center;">
                    <p-autoComplete #productCodeAutoComplete formControlName="fgProductCode"
                      placeholder="Search Finished Goods" (onSelect)="onSelectHandler($event)"
                      [suggestions]="filterFinishGoodList" (completeMethod)="onCompleteMethod($event)"
                      field="productCode" [forceSelection]="true"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.fgProductCode.errors }"
                      [readonly]="isEditMode">
                      <ng-template let-item pTemplate="item" class="text-left w-full p-inputtext-sm">
                        <span>{{item.productCode}}</span>
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>

              <div class="field text-left">
                <label for="website" class="label-required display">{{unitLabel}}</label>
                <span class="p-input-icon-right w-full">
                  <p-autoComplete formControlName="warehouseCode" [dropdown]="!isEditMode" (onSelect)="setWarehouse($event)"
                    [forceSelection]="true" [suggestions]="filtewarehouse" (completeMethod)="filteWarehouse($event)"
                    field="warehouseName" placeholder="Search {{unitLabel}}" styleClass="w-full" class="unit-locked"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseCode.errors }">
                    <ng-template let-item pTemplate="item">
                      <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                    </ng-template>
                  </p-autoComplete>
                </span>
              </div>

              <div class="field text-left " style="padding: 0.2rem;">
                <label class="label-required display">BOM Type</label>
                <div class="align-items-center mt-2" style="margin: 0px 10px 10px 0px;">
                  <p-radioButton name="boMType" value="Manufacture" formControlName="boMType"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.boMType.errors }"></p-radioButton>
                  <label for="ingredient1" class="ml-2">Manufacture</label>
                  &nbsp;
                  &nbsp;
                  <p-radioButton name="boMType" value="Kit" formControlName="boMType"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.boMType.errors }"></p-radioButton>
                  <label for="ingredient2" class="ml-2">Kit</label>
                </div>
              </div>
            </div>

            <div class="field text-left w-6">
              <label for="Project">Project Code</label>
              <div style="display: flex; align-items: center;">
                <input pInputText id="Product" class="p-inputtext-sm ml-2" formControlName="projectBOMCode"
                  class="w-full p-inputtext-sm" [readonly]="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.projectBOMCode.errors }"
                  (keydown)="onKeydown($event)">
                <div style="margin-left: 10px;">
                  <p-button icon="pi pi-search"
                    (click)="getProduct()" [raised]="true" [size]="'small'" severity="info"></p-button>
                </div>
              </div>

              <div class="field text-left mt-4" style="flex: 0.9;">
                <label class="label-required display">Quantity To Produce</label>
                <input pInputText placeholder="0" suffix=" units" type="number" min="0" formControlName="fgQuantity"
                  class="w-full" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.fgQuantity.errors }"
                  (keydown.enter)="focusNextInput($event)">
              </div>

              <div class="field text-left ">
                <label for="UOM" class="label-required display"> Unit Of Measure</label>
                <p-autoComplete formControlName="unitsOfMeasureCode" [dropdown]="true" [suggestions]="filteruom"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.unitsOfMeasureCode.errors }"
                  [forceSelection]="true" (completeMethod)="filterUOM($event)"
                  (onSelect)="onUnitOfMeasureSelect($event)" field="unitsofMeasureCode" placeholder="Search"
                  styleClass="w-full">
                  <ng-template let-item pTemplate="item">
                    <span>{{item.unitsofMeasure}}</span>
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="field text-left">
                <label for="website">Comment</label>
                <input pInputText formControlName="Comment" (keydown)="onKeydown($event)" class="w-full" />
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="flex gap-3">
            <div class="field text-left w-6">
              <label class="label-required display">Start Date</label>
              <div class="p-inputgroup p-lookup">
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="startDate"
                  styleClass="w-full" [showIcon]="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.startDate.errors }"
                  (keydown.enter)="focusNextInput($event)"></p-calendar>
              </div>

              <div class="field text-left mt-5" style="flex: 0.9;">
                <label [class.label-required]="finishClicked" class="display"> Finish Quantity</label>
                <input pInputText placeholder="0" suffix=" units" type="number" min="0" formControlName="quantity"
                  class="w-full" [readonly]="!isEditMode"
                  [ngClass]="{'ng-invalid ng-dirty': finishClicked && formControls.quantity.errors }"
                  (keydown.enter)="focusNextInput($event)">
              </div>

              <div class="field text-left">
                <label for="lotNumber">Lot Number</label>
                <input pInputText formControlName="lotNumber" (keydown)="onKeydown($event)" class="w-full" />
              </div>

            </div>
            <div class="field text-left w-6">
              <label for="EndDate" [class.label-required]="finishClicked" class="display">Finish Date</label>
              <div style="display: flex; align-items: center;">
                <div class="p-inputgroup p-lookup">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="endDate"
                    styleClass="w-full" [showIcon]="true"
                    [ngClass]="{'ng-invalid ng-dirty': finishClicked  && formControls.endDate.errors }"
                    (keydown.enter)="focusNextInput($event)"></p-calendar>
                </div>
              </div>

              <!-- <div class="field text-left mt-5" style="flex: 0.9;">
                <label>Waste Quantity</label>
                <input pInputText placeholder="0" suffix=" units" type="number" min="0" formControlName="wasteQuantity"
                  class="w-full" readonly
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.wasteQuantity.errors }" />
              </div> -->

              <div class="field text-left mt-3" style="flex: 0.9;">
                <label>Quantity On Hand</label>
                <input pInputText placeholder="0" suffix=" units" type="number" readonly min="0"
                  formControlName="quantityOnHand" class="w-full" (keydown.enter)="focusNextInput($event)" />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div>
        <p-tabView>
          <p-tabPanel header="Raw Materials">

            <p-table #dt1 [value]="NewLineItemData" [scrollable]="true" scrollHeight="300px"
              styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
              [paginator]="true" [rows]="10" [selectionPageOnly]="true" [(selection)]="selectedProduct"
              [globalFilterFields]="['ProductCode', 'Quantity', 'UOM']"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10,15,20]" [totalRecords]="NewLineItemData.length">
              <ng-template pTemplate="header">
                <tr>
                  <th>Product Code</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                  <th>Q-Avail</th>
                  <th>Req Qty</th>
                  <th>Product Cost</th>
                  <th>Extended Cost</th>
                  <th>Q-WIP</th>
                  <th>WIP Date</th>
                  <th>Vendor</th>
                  <th>PO No</th>

                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-bomLineitem>
                <tr>
                  <td>{{bomLineitem.productCode}}</td>
                  <td>{{bomLineitem.unitsOfMeasureCode}}</td>
                  <td>{{ getRequiredQty(bomLineitem) }}</td>
                  
                  <td>{{ bomLineitem.quantityAvailable || 0 }}</td>
                  <td>
                    <input pInputText type="number" min="0" step="any" class="p-inputtext-sm" style="width: 100px;"
                      [ngModel]="getReqQty(bomLineitem)" (ngModelChange)="onReqQtyChange(bomLineitem, $event)"
                      [ngModelOptions]="{ standalone: true }" [disabled]="status === 'Batch Finished'" />
                  </td>
                  <td>{{ getProductCost(bomLineitem) }}</td>
                  <td>{{ getExtendedCost(bomLineitem) }}</td>
                  <td>{{bomLineitem.quantityInProcess || 0}}</td>
                  <td style="display: flex; justify-content: center; max-width: 134px;">
                    <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" [(ngModel)]="bomLineitem.wipDate"
                      [ngModelOptions]="{ standalone: true }" [showIcon]="true" placeholder="Select Date"
                      appendTo="body" (onSelect)="onProductEdit(bomLineitem)" (keydown.enter)="focusNextInput($event)">
                    </p-calendar>
                  </td>
                  <td>
                    @if(bomLineitem.vendorName) {
                    {{bomLineitem.vendorName}}
                    } @else {
                    <p-autoComplete [suggestions]="filterVendorList" (completeMethod)="filterVendor($event)"
                      [forceSelection]="true" field="vendorName" placeholder="Select Vendor" [dropdown]="true"
                      (onSelect)="onVendorSelect($event, bomLineitem)" appendTo="body"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && !bomLineitem.vendorCode }"
                      styleClass="w-full p-inputtext-sm">
                      <ng-template let-item pTemplate="item">
                        <span>{{item.vendorCode}} - {{item.vendorName}}</span>
                      </ng-template>
                    </p-autoComplete>
                    }
                  </td>
                  <td>{{ bomLineitem.poNumber || '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>
          <p-tabPanel header="Store Consumption">
            <div class="flex align-items-start pb-4">
              <div>
                <p-button label="Add" class="p-button-outlined button-spacing" icon="pi pi-plus" size="small"
                  (click)="newStoreConsumption('', 'new')"> </p-button>
                <p-button label="Edit" class="p-button-outlined button-spacing" icon="pi pi-pencil" size="small"
                  severity="secondary" *ngIf="selectedProduct && selectedProduct.length === 1"
                  (click)="newStoreConsumption('', 'edit')"> </p-button>
                <p-button class="p-button-outlined button-spacing" icon="pi pi-trash" size="small" severity="danger"
                  (onClick)="deleteStoreConsumption()" *ngIf="selectedProduct && selectedProduct.length > 0"></p-button>
              </div>
            </div>

            <p-table #dt1 [value]="storeconsumptionLineItemData" [scrollable]="true" scrollHeight="350px"
              styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
              [paginator]="true" [rows]="10" [selectionPageOnly]="true" [(selection)]="selectedProduct"
              [globalFilterFields]="['productCode']"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10,15,20]">
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th>Serial Number</th>
                  <th>Employee Name</th>
                  <th>From Date</th>
                  <th>End Date</th>
                  <th>Total Days</th>
                  <!-- <th>Total Labor Cost</th> -->
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-scLineitem>
                <tr>
                  <td>
                    <p-tableCheckbox [value]="scLineitem"></p-tableCheckbox>
                  </td>
                  <td class="text-blue-500 underline" style="cursor: pointer;"
                    (click)="newStoreConsumption(scLineitem, 'edit')">
                    {{scLineitem.scCode}}
                  </td>
                  <td>{{scLineitem.empName}}</td>
                  <td>{{scLineitem.fromDate | date: 'dd/MM/yyyy'}}</td>
                  <td>{{scLineitem.endDate | date: 'dd/MM/yyyy'}}</td>
                  <td>{{scLineitem.totDays}}</td>
                  <!-- <td>{{scLineitem.totLaborCost}}</td> -->
                </tr>
              </ng-template>

            </p-table>

          </p-tabPanel>
          <p-tabPanel header="Delivery Challan">

            <p-table #dt1 [value]="challanList" [scrollable]="true" scrollHeight="613px"
              styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
              [paginator]="true" [rows]="10" (onPage)="loadChallan($event)" [(selection)]="selectedChallan"
              [globalFilterFields]="['purchaseOrderNumber','vendor.vendorCode','vendor.vendorName','warehouse.warehouseCode','poTotal','requestedDate','purchaseOrder_Status']"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10 ,15, 20]">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 4rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th>D/C Number</th>
                  <th>Challan Date</th>
                  <th>Vendor Code</th>
                  <th>Vendor Name</th>
                  <th>Challan Type</th>
                  <th>Status</th>
                  <th>Created By</th>
                  <th>Print</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-challan>
                <tr>
                  <td>
                    <p-tableCheckbox [value]="challan"></p-tableCheckbox>
                  </td>
                  <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editChallan(challan)">
                    {{challan.deliverychallanNo}}
                  </td>
                  <td>{{challan.deliverychallanDate | date: 'dd/MM/yy' }}</td>
                  <td>{{challan.vendor.vendorCode}}</td>
                  <td>{{challan.vendor.vendorName}}</td>
                  <td>{{challan.challanType}} </td>
                  <td [ngStyle]="{
                            'color': challan.status === 'Delivered' ? '#0fdf00' :
                            challan.status === 'Returned' ? '#fa8202' : 'blue'
                          }">{{challan.status}} </td>

                  <td>{{challan.createdBy}}</td>
                  <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"></span></td>

                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9">No Records found.</td>
                </tr>
              </ng-template>
            </p-table>

          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </form>
</p-card>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>